import { AxiosResponse } from 'axios';
import { KeyValue } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';
import { SearchgridTemplateRequest } from '@/main/models/request/templateEmailNotificationCompanyRequest';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { SearchgridTemplateResponse } from '@/main/models/response/templateEmailNotificationCompanyResponse';

export abstract class ITemplateEmailNotificationCompanyApi {
  abstract getSearchGridTemplate(request: SearchgridTemplateRequest): Promise<AxiosResponse<PaginationResponse<SearchgridTemplateResponse>>>;
}

